<ziro-fieldset-header [legend]="'tkey;shared.dnWizard.dnDetails.callForward.header'">
  <ziro-select fieldId="forwardAllCss"></ziro-select>
  <ziro-select fieldId="secondaryClassOfServiceForForwardAll"></ziro-select>
  <ziro-text fieldId="noAnswerRingDuration"></ziro-text>
  <ziro-directory-number-call-forward fieldId="forwardAll"></ziro-directory-number-call-forward>
  <ziro-directory-number-call-forward fieldId="forwardBusyExternal"></ziro-directory-number-call-forward>
  <ziro-directory-number-call-forward fieldId="forwardNoAnswerExternal"></ziro-directory-number-call-forward>
</ziro-fieldset-header>
